<template>
  <div>
    <b-row class="mt-1 mb-1">
      <b-col class="font-weight-bold">
        Názov zákazky:
      </b-col>
      <b-col>
        {{ orderData.title}}
      </b-col>
    </b-row>
    <b-row class="mt-1 mb-1">
      <b-col class="font-weight-bold">
        Vypísaná:
      </b-col>
      <b-col>
        {{ orderData.concludedOn | formatDate }}
      </b-col>
    </b-row>
    <b-row class="mt-1 mb-1">
      <b-col class="font-weight-bold">
        Vytvorená:
      </b-col>
      <b-col>
        {{ orderData.createdOn | formatDateTime }}
      </b-col>
    </b-row>
    <b-row class="mt-1 mb-1">
      <b-col class="font-weight-bold">
        Hlavný CPV kód:
      </b-col>
      <b-col>
        {{ orderData.mainCpv }}
      </b-col>
    </b-row>
    <b-row class="mt-1 mb-1">
      <b-col class="font-weight-bold">
        Predpokladaná hodnota:
      </b-col>
      <b-col>
        {{ orderData.estimatedValueAmount }} {{orderData.estimatedValueCurrency}}
      </b-col>
    </b-row>
    <b-row class="mt-1 mb-1">
      <b-col class="font-weight-bold">
        DPH:
      </b-col>
      <b-col>
        {{ orderData.estimatedVatIncluded | formatBoolean }} <span v-if="orderData.estimatedVatIncluded">{{orderData.estimatedVatRate}} %</span>
      </b-col>
    </b-row>
    <b-row class="mt-1 mb-1">
      <b-col class="font-weight-bold">
        Ponuky:
      </b-col>
    </b-row>
    <b-row class="mt-1 mb-1">
      <b-col>
        <table class="table table-lg mb-0 offers-table">
          <thead>
            <tr class="text-muted">
              <th>Dodávateľ</th>
              <th>IČO</th>
              <th>Hodnota</th>
              <th>DPH</th>
            </tr>
          </thead>
          <tbody>
          <tr v-for="(offer, index) in orderData.offers" :key="`offer-${index}`">
            <td>
              {{ offer.namesList }}
            </td>
            <td>
              {{ offer.cinsList }}
            </td>
            <td>
              {{ offer | formatValue }}
            </td>
            <td>
              {{ offer | formatVat }}
            </td>
          </tr>  
          </tbody>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'OrderDetail',
  props: ['orderData'],
  data() {
    return {}
  },  
  filters: {
    formatDateTime (value) {
      return value ? moment(value).format('DD. MM. YYYY HH:mm') : ''
    },
    formatDate (value) {
      return value ? moment(value).format('DD. MM. YYYY') : ''
    },
    formatBoolean (value) {
      if (value === null) {
        return 'Neznáme';
      } else {
        return value ? 'Áno' : 'Nie';
      }
    },
    formatValue (offer) {
      return `${offer.amount} ${offer.currency}`
    },
    formatVat (offer) {
      return offer.vatIncluded ? `${offer.vatRate} %` : 'Nie'
    }
  },
  created() {
    this.orderData.offers.forEach(offer => {
      let names = offer.contractors.map(contractor => contractor.businessName).join(', ')
      let cins = offer.contractors.map(contractor => contractor.cin).join(', ')
      offer['namesList'] = names
      offer['cinsList'] = cins
    })
  }
}
</script>